module.exports = __webpack_public_path__ + "static/media/logo.4254072d.svg";